// для расчёта ширины текста в пикселях, юзать по примеру в проекте

type Font = {
    font: string,
    fontSize: number,
    letterSpacing: number
}

export const useCalculateTextWidth = (text: string, font: Font): number => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d') as CanvasRenderingContext2D & { letterSpacing: string };
    context.font = `${font.fontSize}px ${font.font}`;
    context.letterSpacing = `${font.letterSpacing}px`;
    return context.measureText(text).width;
};

